<div class="dialog-header">
  <div class="header-title"><span>Copy - {{project.name}}</span></div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content activity-dialog">

  <form #projectActivityForm="ngForm">
    <div class="form-block">
      <div class="form-row" *ngFor="let projectName of projectNames; let index = index; trackBy: trackEntityById;">
        <div class="icon-block">
          <mat-icon>format_list_bulleted</mat-icon>
        </div>
        <div class="field-block">
          <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [(ngModel)]="projectNames[index]">
        </div>
        <div class="icon-block delete-icon" (click)="deleteField(index)">
          <mat-icon>delete</mat-icon>
        </div>
      </div>
    </div>
    <div class="add-btn-block">
      <button mat-button class="add-btn" (click)="addField()" tabindex="1" type="submit"
              [disabled]="submitLoading">
        <span>Add Unit</span>
      </button>
    </div>
    <div class="save-btn-block">
      <button mat-button class="save-btn" (click)="copyProjects()" tabindex="1" type="submit"
              [disabled]="submitLoading" [ngClass]="{'disabled-button': submitLoading}">
        <span *ngIf="!submitLoading">Copy</span>
        <lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
      </button>
    </div>
  </form>
</div>
